import {
    takeEvery,
    put
} from 'redux-saga/effects';

import ContactService from 'services/ContactService';
import api from 'services/restApiHelper';
const baseUrl = process.env.REACT_APP_BASE_URL;

export function* contactFlow(action) {
    try {
        // We MUST encode any parameter that has special characters before making the api call.  Ajax used to do this
        // for us, but now that we are using the fetch api for web service calls, we have to do this ourselves
        const name = action.name;
        const email = encodeURIComponent(action.email);
        const message = encodeURIComponent(action.message);
        const category = encodeURIComponent('ARM - PCM Processes');
        const response = yield api.post(`${baseUrl}/submit-ticket?category=${category}&sender-name=${name}&sender-email=${email}&sender-question=${message}`);
        yield put({
            type: ContactService.CONTACT_SEND_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: ContactService.CONTACT_SEND_ERROR,
            error
        });
    }
}

export function* watchContactServiceRequests() {
    yield takeEvery(ContactService.CONTACT_SEND_START, contactFlow);
}



// WEBPACK FOOTER //
// ./src/services/sagas/ContactServiceSagas.js